var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentGrayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 42,
    viewBox: "0 0 33 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5712 2.00184C18.3734 2 18.1513 2 17.8974 2H8.62888C6.3087 2 5.14774 2 4.26155 2.46019C3.48203 2.86499 2.84872 3.51044 2.45154 4.3049C2 5.20809 2 6.3913 2 8.75597V33.2448C2 35.6095 2 36.7912 2.45154 37.6944C2.84872 38.4889 3.48203 39.1355 4.26155 39.5403C5.14688 40 6.30645 40 8.62214 40L24.3775 40C26.6932 40 27.851 40 28.7364 39.5403C29.5159 39.1355 30.1513 38.4889 30.5485 37.6944C30.9996 36.7921 30.9996 35.612 30.9996 33.252V15.3542C30.9996 15.0951 30.9995 14.8685 30.9977 14.6667M18.5712 2.00184C19.1629 2.00732 19.5372 2.02923 19.8945 2.11666C20.3172 2.22009 20.721 2.39111 21.0917 2.62261C21.5096 2.88364 21.8685 3.24939 22.5845 3.97917L29.0587 10.5774C29.7752 11.3076 30.1314 11.6718 30.3876 12.0979C30.6148 12.4756 30.7828 12.8875 30.8843 13.3184C30.97 13.6824 30.992 14.064 30.9977 14.6667M18.5712 2.00184V7.91111C18.5712 10.2758 18.5712 11.4573 19.0227 12.3605C19.4199 13.1549 20.0532 13.8021 20.8327 14.2069C21.7181 14.6667 22.8776 14.6667 25.1933 14.6667H30.9977M30.9977 14.6667H31",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentGrayIcon);
export default __webpack_public_path__ + "static/media/document-gray-icon.505efdbb60850da8cd1bc17d283ca95d.svg";
export { ForwardRef as ReactComponent };